import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../../api/client";
import PartnerShell, { PartnerNotice, formatDay, formatVisit } from "./PartnerShell";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function PartnerPatientDetail() {
  const { ref } = useParams();
  const [p, setP] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let live = true;
    setP(null);
    setStatus(null);
    api.get(`/partner/patients/${encodeURIComponent(ref)}`)
      .then((res) => { if (live) setP(res.data); })
      .catch((err) => { if (live) setStatus(err?.response?.status || 500); });
    return () => { live = false; };
  }, [ref]);

  return (
    <PartnerShell>
      <Link to="/partner" className="mb-4 inline-flex items-center gap-1 text-sm text-blue-700 hover:underline">
        <ArrowLeft className="h-4 w-4" /> My patients
      </Link>
      {status === 404 ? (
        <div data-testid="partner-not-found" className="rounded-lg border border-slate-200 bg-white p-6 text-slate-600">
          Patient not found.
        </div>
      ) : status ? <PartnerNotice status={status} /> : !p ? (
        <div className="text-slate-500"><Loader2 className="mr-2 inline h-4 w-4 animate-spin" />Loading…</div>
      ) : (
        <div className="rounded-lg border border-slate-200 bg-white p-6" data-testid="partner-patient">
          <h1 className="mb-4 text-xl font-semibold text-slate-900">{p.last_name}, {p.first_name}</h1>
          <dl className="grid grid-cols-1 gap-x-8 gap-y-3 text-sm sm:grid-cols-2">
            <div><dt className="text-slate-500">Date of birth</dt><dd>{formatDay(p.date_of_birth)}</dd></div>
            <div><dt className="text-slate-500">Referred</dt><dd>{formatDay(p.referral_date)}</dd></div>
            <div><dt className="text-slate-500">Status</dt><dd>{p.tab_label} since {formatDay(p.tab_since)}</dd></div>
            <div><dt className="text-slate-500">Next visit</dt><dd>{formatVisit(p.next_visit)}</dd></div>
            <div><dt className="text-slate-500">Clinic</dt><dd>{p.clinic}</dd></div>
          </dl>
          <h2 className="mb-2 mt-6 text-sm font-semibold text-slate-900">Status history</h2>
          <ol className="text-sm" data-testid="partner-history">
            {(p.history || []).slice().reverse().map((h, i) => (
              <li key={`${h.tab}-${h.since}-${i}`} className="flex gap-4 border-t border-slate-100 py-1.5">
                <span className="w-32 text-slate-500">{formatDay(h.since)}</span>
                <span>{h.label}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </PartnerShell>
  );
}
